<template>
  <div>
    <div v-if="hasError" class="d-flex vh-100 align-items-center justify-content-center">
      <ErrorBox :error-message="serverErrorMessage" class="w-50" />
    </div>
    <main
      v-if="isActivatedSuccessfully"
      class="view-activated-successfully d-flex flex-row space-between"
    >
      <section class="d-flex">
        <div class="colorfull-card yellow" />
        <div class="colorfull-card red" />
        <div class="colorfull-card blue" />
      </section>
      <Envelope :configurations="EnvelopeConfigurations" />
      <section class="d-flex">
        <div class="balloon-line" />
        <div class="balloon">
          <img src="@/assets/Balloon.png">
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import RootAccessor from '@/mixins/root-accessor'
import Envelope from '@/components/Envelope.vue'
import ActivatedSuccessfullyLetter from '@/components/ActivatedSuccessfullyLetter.vue'
import utility from '@/utilities/utility'
import ErrorBox from '@/components/ErrorBox.vue'
import { mapActions } from 'vuex'

export default {
  name: 'ActivatedSuccessfully',
  components: {
    Envelope,
    ActivatedSuccessfullyLetter,
    ErrorBox
  },
  mixins: [RootAccessor],
  data () {
    return {
      EnvelopeConfigurations: {
        HasLetter: true,
        LetterText: ActivatedSuccessfullyLetter,
        HasButton: true,
        ButtonText: this.$t('activedSuccessfully.loginToPortal')
      },
      serverErrorMessage: null,
      isActivatedSuccessfully: false
    }
  },
  computed: {
    hasError () {
      return !!this.serverErrorMessage
    }
  },
  methods: {
    ...mapActions({
      checkRequestStatus: "registration/checkRequestStatus",
      confirmPin: "registration/confirmPin",
      setTrialPeriod: "registration/setTrialPeriod"
    }),
    emailActivation () {
      var confirmInput = {
        requesterServiceRefCode: utility.getQueryStringValue('r'),
        userInput: utility.getQueryStringValue('p')
      }
      this.confirmPin(confirmInput)
        .then(response => {
          var result = response.body.result
          if (result.status === 'Success') {
            return this.checkConfirmStatus(confirmInput)
          } else {
            this.serverErrorMessage = this.$t(
              'validations.messages.server_error',
              {
                fieldName: this.$t('security.pinInput')
              }
            )
          }
        })
        .catch(err => {})
    },
    checkConfirmStatus (confirmInput) {
      var promise = this.checkRequestStatus(
        confirmInput.requesterServiceRefCode
      ).then(response => {
        var result = response.body.result

        if (result === 'Failed') {
          this.serverErrorMessage = this.$t(
            'validations.messages.server_error'
          )
        } else if (result === 'FailedVerification') {
          this.serverErrorMessage = this.$t(
            "validations.messages.server_error"
          ); 
        } 
        else if (result === 'IdentityVerified') {
          this.serverErrorMessage = this.$t(
            "validations.messages.server_error"
          ); 
        } 
        else if (result === "Finalized") {
          this.serverErrorMessage = null;
          this.isActivatedSuccessfully = true;
          var reqServiceRefCode = confirmInput.requesterServiceRefCode;
          this.setTrialPeriod(reqServiceRefCode);
        } else {
          setTimeout(() => {
            this.checkConfirmStatus(confirmInput)
          }, 2000)
        }
      })
      return promise
    }
  },
  created () {
    this.emailActivation()
  },
  mounted () {
    this.setBodyClass('overflow-hidden')
  },
  destroyed () {
    this.clearBodyClass()
  }
}
</script>
